import moment from "moment-timezone";
import { LoadState, POLICIES } from "../../../constants/enums";
import {
  STANDARD_APP_DATE_FORMAT,
  STANDARD_APP_TIME_FORMAT,
} from "../../../constants/constants";
import { IHabitationalAdditionalCoverage, IHabitationalAdditionalInterest, IHabitationalLiabilityExtension, IHabitationalSchedulePersonalProperty, IHabitationalWaterCraftTrailer } from "../../habitationalPolicy/habitationalClaim/habitationalClaim.types";
import { IAutomobileAuthorityReport } from "../../automobileDriver/automobileDriver.types";
import { getUniqueId } from "../../../helpers/getUniqueId";
import { IFileUpload } from "../../../features/FileUpload/components/FileUpload.type";

export interface IBusinessBasicDetailsState {
  customerInfo: {
    data: ICustomerInfo;
    loading: LoadState;
    error: string | null;
  };
  additional_insured: {
      list: IBusinessAdditionalInsured[]
      data: IBusinessAdditionalInsured;
      loading: LoadState;
      error: string | null;
    };
  priorPolicy: {
    data: IPriorPolicy;
    loading: LoadState;
    error: string | null;
  };
  policyAdmin: {
    data: IPolicyAdmin;
    loading: LoadState;
    error: string | null;
  };
  policyAdminManager: {
    data: IPolicyAdminManager;
    loading: LoadState;
    error: string | null;
  };
  claim: {
    data: IClaims[];
    claim: IClaims;
    loading: LoadState;
    error: string | null;
  };
  premium: {
    data: IPremium;
    loading: LoadState;
    error: string | null;
  };
  attachment: {
    list: IBusinessAttachment[];
    listLoading: LoadState;
    data: IBusinessAttachment;
    loading: LoadState;
    error: string | null;
  };

  customerPoliycId?: number | null;
}

export interface IBusinessAttachment {
  customer_policy_id: number | null;
  serial_number: number | null;
  document_name: string | null;
  file_upload: string | null;
  description: string | null;
  send_attachment: number;
  status: string;
}
export interface ICustomerInfo {
  policy_id: number;
  customer_id: number;
  customer_policy_id: number | null;
  customer_name: string | null;
  customer_code: string | null;
  form_of_business: string | number | null;
  language: string | null;
  line_of_business: string | null;
  sub_type: string | null;
  effective_date: string;
  binder_number: string | null;
  expiry_date: string;
  segment: string[];
  transaction_type: string | null;
  residential_or_business: string | null;
  address: string | null;
  unit_or_suite: string | null;
  city: string | null;
  province_or_state: string | null;
  postal_code: string | null;
  country: string | null;
  policy_status: string | null;
  current_policy_status: string | null;
  date_cancelled: string | null;
  cancellation_reason: string | null;
  cancellation_type: string | null;
  program: string | null;
  type_of_policy: string | null;
  quote_number: string | null;
  policy_number: string | null;
  effective_time: string;
  send_invoices_renewal_and_receivacble_letter_via_emails: boolean | null;
  send_statements_via_email: boolean | null;
  send_eDocs_via_email: boolean | null;
  status: string;
  additional_insured: IBusinessAdditionalInsured[]
}

export interface IBusinessAdditionalInsured {
  customer_policy_id: number | null;
  incremental_number: null;
  customer_id: number;
  type: string | null;
  customer_name: string | null;
  address: string | null;
  unit_or_suite: string | null;
  city: string | null;
  province_or_state: string | null;
  country: string | null;
  postal_code: string | null;
  phone_number: string | null;
  mobile_number: string | null;
  gender: string | null;
  birth_date: string | null;
  marital_status: string | null;
  status: string;
}

export interface IPriorPolicy {
  customer_policy_id: number;
  line_of_business: string | null;
  policy_expiry_date: string | null;
  current_insurer: string | null;
  expiring_premium: string | null;
  current_status: string | null;
  non_payment_code: string | null;
  non_payment_date: string | null;
  insurer: string | null;
  amount_owing: string | null;
  prior_policy_number: string | null;
}

export interface IPolicyAdmin {
  customer_policy_id: number;
  insurer: string | null;
  broker_code: string | null;
  comission_code: string | null;
  commission_percentage: string | null;
  policy_fee: string | null;
  branch_code: string | null;
  producer_1: string | null;
  producer_1_code: string | null;
  producer_2: string | null;
  producer_2_code: string | null;
  producer_3: string | null;
  producer_3_code: string | null;
  marketer: string | null;
  marketer_code: string | null;
  csr: string | null;
  csr_code: string | null;
  billing_account_number: string | null;
  create_ts?: string;
}
export interface IPolicyAdminManager {
  customer_policy_id: number;
  insurer: string | null;
  broker_code: string | null;
  comission_code: string | null;
  policy_fee: string | null;
  branch_code: string | null;
  producer_1: string | null;
  producer_1_code: string | null;
  producer_2: string | null;
  producer_2_code: string | null;
  producer_3: string | null;
  producer_3_code: string | null;
  marketer: string | null;
  marketer_code: string | null;
  csr: string | null;
  csr_code: string | null;
  billing_account_number: string | null;

  producer_one_endorsement_percentage: string | null;
  producer_one_new_percentage: string | null;
  producer_one_renewal_percentage: string | null;

  producer_two_endorsement_percentage: string | null;
  producer_two_new_percentage: string | null;
  producer_two_renewal_percentage: string | null;

  producer_three_endorsement_percentage: string | null;
  producer_three_new_percentage: string | null;
  producer_three_renewal_percentage: string | null;

  house_new_percentage: string | null;
  house_renewal_percentage: string | null;
  house_endorsement_percentage: string | null;

  branch_new_percentage: string | null;
  branch_renewal_percentage: string | null;
  branch_endorsement_percentage: string | null;
}

export interface IClaims {
  customer_id: number | null;
  customer_policy_id: number;
  producer_one_id: string | null;
  producer_one_code: string | null;
  claim_number: string | null;
  incremental_number: number | null;
  date_of_loss: string | null;
  time_of_loss: string;
  value_of_loss: string | null;
  risk_location: string | null;
  amount_paid_dollar: string | null;
  loss_details: string | null;
  ours: string | null;


  customer_name: string | null;
  customer_code: string | null;
  policy_number: string | null;
  line_of_business: string | null;
  branch_code: string | null;
  policy_status: string | null;
  insurer: string | null;
  address: string | null;
  city: string | null;
  country: string | null;
  province_or_state: string | null;
  postal_code: string | null;
  effective_date: string | null;
  effective_time: string | null;
  expiry_date: string | null;
  expiry_time: string | null;
  file_upload: string | null;
  location_of_loss: string | null;
  coverage_information: {
    coverage_number: number | null,
    type: string | null;
    package_form_and_type: string | null;
    single_limit: string | null;
    dwelling_building: string | null;
    detached_structures: string | null;
    personal_property: string | null;
    additional_living_expenses: string | null;
    legal_liability: string | null;
    voluntary_medical_payment: string | null;
    voluntary_property_damage: string | null;
    deductible: string | null;
  };
  additional_coverage: IHabitationalAdditionalCoverage[];
  liability_extension: IHabitationalLiabilityExtension[];
  schedule_personal_property: IHabitationalSchedulePersonalProperty[];
  watercraft_and_trailer: IHabitationalWaterCraftTrailer[];
  additional_interest: IHabitationalAdditionalInterest[];
  details_of_loss: {
    risk_no: string | null;
    date: string;
    time: string;
    loss_type: string | null;
    description: string | null;
  };
  authority_report: IAutomobileAuthorityReport[];
  injured_party: {
    name: string | null;
    address: string | null;
    unit_or_suite: string | null;
    city: string | null;
    province_or_state: string | null;
    postal_code: string | null;
    country: string | null;
    contact_number: number | null;
    home: string | null;
    business: string | null;
    cell: string | null;
    fax: string | null;
    preferred_language: string | null;
    specify_type: string | null;
    nature_of_injury: string | null;
    hospitalized: string | null;
  };
  remarks: string | null;
  witness_contact_information: {
    name: string | null;
    address: string | null;
    unit_or_suite: string | null;
    city: string | null;
    province_or_state: string | null;
    postal_code: string | null;
    country: string | null;
    contact_number: number | null;
    home: string | null;
    business: string | null;
    cell: string | null;
    fax: string | null;
    preferred_language: string | null;
  };
  file_upload_two: IFileUpload[] | null;
  adjuster_assignment_information: {
    name: string | null;
    address: string | null;
    unit_or_suite: string | null;
    city: string | null;
    province_or_state: string | null;
    postal_code: string | null;
    country: string | null;
    contact_number: number | null;
    home: string | null;
    business: string | null;
    cell: string | null;
    fax: string | null;
    email: string | null;
    reported_by: string | null;
    reported_date: string | null;
    reported_time: string | null;
    reported_to_company_by: string | null;
    reported_to_company_date: string | null;
    reported_to_company_time: string | null;
  };
  status: string;
  // producer: string | null;
  // branch: string | null;
  // adjuster: string | null;
  // witness: string | null;
  // witness_phone: string | null;
  // witness_name: string | null;
  // loss_reported_to_police: string | null;
  // report_number: string | null;
  // phone: string | null;
  // phone_ext: string | null;
  // mobile: string | null;
  // email: string | null;
  // company_name: string | null;
  // at_fault: string | null;
  // claim_status: string | null;
  // third_party_liability: string | null;
  // bodily_injury: string | null;
  // accidents_benefits: string | null;
  // dcpd: string | null;
  // collision: string | null;
  // comprehensive: string | null;
  // reserves: string | null;
  // cgl: string | null;
  // stock: string | null;
  // crime: string | null;
  // equipment_breakdown: string | null;
  // business_interruption: string | null;
  // other: string | null;
  // total_claim: string | null;
  // contact_name: string | null;
  // contact_phone: string | null;
  // contact_phone_ext: string | null;
  // contact_mobile: string | null;
  // contact_email: string;
  // preferred_contact_method: string | null;
  created_from: string | null;
}

export interface IBusinessPremiumPaymentSchedule {
  id: string;
  installment_number: string;
  installment_amount: string;
  installment_date: string;
}

export interface IPremium {
  customer_policy_id: number;
  policy_premium: string | null;
  agency_bill_or_direct_bill: string | null;
  payment_plan: string | null;
  premium_finance_contract_number: string | null;
  financed_by: string | null;
  default_tax_region: string | null;
  tax_1: string | null;
  tax_2: string | null;
  tax_exempt: string | null;
  tax_exempt_reason: string | null;
  premium_finance: string | null;
  payment_schedule: IBusinessPremiumPaymentSchedule[];
}

export const  INITIAL_CLAIM: IClaims = 
{
  customer_id: null,
  producer_one_id: null,
  producer_one_code: null,
  customer_policy_id: 0,
  claim_number: null,
  incremental_number: null,
  date_of_loss: null,
  time_of_loss: moment().format(STANDARD_APP_TIME_FORMAT),
  value_of_loss: null,
  risk_location: null,
  amount_paid_dollar: null,
  loss_details: null,
  ours: null,
  status: "Open",

  created_from: null,
  customer_name: null,
  customer_code: null,
  policy_number: null,
  line_of_business: null,
  branch_code: null,
  policy_status: null,
  insurer: null,
  address: null,
  city: null,
  country: null,
  province_or_state: null,
  postal_code: null,
  effective_date: null,
  effective_time: null,
  expiry_date: null,
  expiry_time: null,
  file_upload: null,
  location_of_loss: null,
  coverage_information: {
    coverage_number: null,
    type: null,
    package_form_and_type: null,
    single_limit: null,
    dwelling_building: null,
    detached_structures: null,
    personal_property: null,
    additional_living_expenses: null,
    legal_liability: null,
    voluntary_medical_payment: null,
    voluntary_property_damage: null,
    deductible: null
  },
  additional_coverage: [
    {
      key: getUniqueId(),
      code: null,
      coverage_description: null,
      limit: null,
      deductible: null,
      deductible_type: null,
      one_type_of: null,
    },
    {
      key: getUniqueId(),
      code: null,
      coverage_description: null,
      limit: null,
      deductible: null,
      deductible_type: null,
      one_type_of: null,
    },
  ],
  liability_extension: [
    {
      key: getUniqueId(),
      code: null,
      liability_coverage_description: null,
      number_of: null,
      type_of_one: null,
      type_of_two: null,
    },
    {
      key: getUniqueId(),
      code: null,
      liability_coverage_description: null,
      number_of: null,
      type_of_one: null,
      type_of_two: null,
    },
  ],
  schedule_personal_property: [
    {
      key: getUniqueId(),
      number: "1",
      class_code: null,
      description: null,
      coverage_code: null,
      qualifier_one: null,
      qualifier_two: null,
      purchase_appraisal_date: null,
      deductible: null,
      disc: null,
      amt_of_ins: null,
    },
    {
      key: getUniqueId(),
      number: "2",
      class_code: null,
      description: null,
      coverage_code: null,
      qualifier_one: null,
      qualifier_two: null,
      purchase_appraisal_date: null,
      deductible: null,
      disc: null,
      amt_of_ins: null,
    },
  ],
  watercraft_and_trailer: [
    {
      key: getUniqueId(),
      number: "1",
      type: null,
      year: null,
      length: null,
      description: null,
      coverage: null,
      deductible: null,
      amt_of_ins: null,
    },
    {
      key: getUniqueId(),
      number: "2",
      type: null,
      year: null,
      length: null,
      description: null,
      coverage: null,
      deductible: null,
      amt_of_ins: null,
    },
  ],
  additional_interest: [
    {
      key: getUniqueId(),
      interested_party: null,
      name_address: null,
      nature_of_interest: null,
    },
    {
      key: getUniqueId(),
      interested_party: null,
      name_address: null,
      nature_of_interest: null,
    },
    {
      key: getUniqueId(),
      interested_party: null,
      name_address: null,
      nature_of_interest: null,
    },
  ],
  details_of_loss: {
    risk_no: null,
    date: "",
    time: "",
    loss_type: null,
    description: null
  },
  authority_report: [
    {
      key: getUniqueId(),
      authority: "Police",
      municipality_city: null,
      division_station_location_number: null,
      officer_or_contact_name: null,
      contact_number: null,
      badge_number: null,
      date_reported: null,
      occurence_or_report_number: null,
      charges_laid_or_other: null,
    },
    {
      key: getUniqueId(),
      authority: "Fire Department",
      municipality_city: null,
      division_station_location_number: null,
      officer_or_contact_name: null,
      contact_number: null,
      badge_number: null,
      date_reported: null,
      occurence_or_report_number: null,
      charges_laid_or_other: null,
    },
    {
      key: getUniqueId(),
      authority: "Other",
      municipality_city: null,
      division_station_location_number: null,
      officer_or_contact_name: null,
      contact_number: null,
      badge_number: null,
      date_reported: null,
      occurence_or_report_number: null,
      charges_laid_or_other: null,
    },
  ],
  injured_party: {
    name: null,
    address: null,
    unit_or_suite: null,
    city: null,
    province_or_state: null,
    postal_code: null,
    country: null,
    contact_number: null,
    home: null,
    business: null,
    cell: null,
    fax: null,
    preferred_language: null,
    specify_type: null,
    nature_of_injury: null,
    hospitalized: null
  },
  remarks: null,
  witness_contact_information: {
    name: null,
    address: null,
    unit_or_suite: null,
    city: null,
    province_or_state: null,
    postal_code: null,
    country: null,
    contact_number: null,
    home: null,
    business: null,
    cell: null,
    fax: null,
    preferred_language: null
  },
  adjuster_assignment_information: {
    name: null,
    address: null,
    unit_or_suite: null,
    city: null,
    province_or_state: null,
    postal_code: null,
    country: null,
    contact_number: null,
    home: null,
    business: null,
    cell: null,
    fax: null,
    email: null,
    reported_by: null,
    reported_date: null,
    reported_time: null,
    reported_to_company_by: null,
    reported_to_company_date: null,
    reported_to_company_time: null
  },
  file_upload_two: null
};

export const initialBasicDetails: IBusinessBasicDetailsState = {
  customerInfo: {
    data: {
      customer_name: "",
      policy_id: 0,
      customer_id: 0,
      customer_policy_id: null,
      unit_or_suite: null,
      customer_code: null,
      form_of_business: null,
      language: null,
      line_of_business: POLICIES.BUSINESS_POLICY,
      sub_type: null,
      effective_date: moment().format(STANDARD_APP_DATE_FORMAT),
      expiry_date: moment().add(1, "year").format(STANDARD_APP_DATE_FORMAT),
      effective_time: moment().startOf("day").add(1, "minute").format(STANDARD_APP_TIME_FORMAT),
      transaction_type: null,
      segment: [],
      residential_or_business: "",
      address: "",
      city: "",
      province_or_state: "",
      country: "",
      postal_code: "",
      policy_status: "",
      current_policy_status: "Prospect",
      date_cancelled: null,
      cancellation_reason: null,
      cancellation_type: null,
      program: null,
      type_of_policy: null,
      quote_number: null,
      policy_number: null,
      binder_number: null,

      send_invoices_renewal_and_receivacble_letter_via_emails: true,
      send_statements_via_email: true,
      send_eDocs_via_email: true,
      status: "ACTIVE",
      additional_insured: [],
    },
    loading: LoadState.NotLoaded,
    error: null,
  },
  additional_insured: {
    data: {
      customer_policy_id: 0,
      incremental_number: null,
      customer_id: 0,
      type: null,
      customer_name: null,
      address: null,
      unit_or_suite: null,
      city: null,
      province_or_state: null,
      country: null,
      postal_code: null,
      phone_number: null,
      mobile_number: null,
      gender: null,
      birth_date: null,
      marital_status: null,
      status: "ACTIVE",
    },
    list: [],
    loading: LoadState.NotLoaded,
    error: null,
  },
  priorPolicy: {
    data: {
      customer_policy_id: 0,
      line_of_business: null,
      policy_expiry_date: null,
      current_insurer: null,
      expiring_premium: null,
      current_status: null,
      non_payment_code: null,
      non_payment_date: null,
      insurer: null,
      amount_owing: null,
      prior_policy_number: null
    },
    loading: LoadState.NotLoaded,
    error: null,
  },
  policyAdmin: {
    data: {
      customer_policy_id: 0,
      insurer: null,
      broker_code: null,
      comission_code: null,
      commission_percentage: null,
      policy_fee: null,
      branch_code: null,
      producer_1: null,
      producer_1_code: null,
      producer_2: null,
      producer_2_code: null,
      producer_3: null,
      producer_3_code: null,
      marketer: null,
      marketer_code: null,
      csr: null,
      csr_code: null,
      billing_account_number: null,
    },
    loading: LoadState.NotLoaded,
    error: null,
  },
  policyAdminManager: {
    data: {
      customer_policy_id: 0,
      insurer: null,
      broker_code: null,
      comission_code: null,
      policy_fee: null,
      branch_code: null,
      producer_1: null,
      producer_1_code: null,
      producer_2: null,
      producer_2_code: null,
      producer_3: null,
      producer_3_code: null,
      marketer: null,
      marketer_code: null,
      csr: null,
      csr_code: null,
      billing_account_number: null,
      producer_one_endorsement_percentage: null,
      producer_one_new_percentage: null,
      producer_one_renewal_percentage: null,
      producer_two_endorsement_percentage: null,
      producer_two_new_percentage: null,
      producer_two_renewal_percentage: null,
      producer_three_endorsement_percentage: null,
      producer_three_new_percentage: null,
      producer_three_renewal_percentage: null,
      house_new_percentage: null,
      house_renewal_percentage: null,
      house_endorsement_percentage: null,
      branch_renewal_percentage: null,
      branch_new_percentage: null,
      branch_endorsement_percentage: null,
    },
    loading: LoadState.NotLoaded,
    error: null,
  },
  claim: {
    data: [],
    loading: LoadState.NotLoaded,
    claim: INITIAL_CLAIM,
    error: null,
  },
  premium: {
    data: {
      customer_policy_id: 0,
      policy_premium: null,
      agency_bill_or_direct_bill: null,
      payment_plan: null,
      premium_finance_contract_number: null,
      financed_by: null,
      default_tax_region: "ON",
      tax_1: null,
      tax_2: null,
      tax_exempt: null,
      tax_exempt_reason: null,
      premium_finance: null,
      payment_schedule: [
        {
          id: getUniqueId(),
          installment_number: "",
          installment_amount: "",
          installment_date: "",
        },
        {
          id: getUniqueId(),
          installment_number: "",
          installment_amount: "",
          installment_date: "",
        },
        {
          id: getUniqueId(),
          installment_number: "",
          installment_amount: "",
          installment_date: "",
        },
        {
          id: getUniqueId(),
          installment_number: "",
          installment_amount: "",
          installment_date: "",
        },
        {
          id: getUniqueId(),
          installment_number: "",
          installment_amount: "",
          installment_date: "",
        },
        {
          id: getUniqueId(),
          installment_number: "",
          installment_amount: "",
          installment_date: "",
        },
        {
          id: getUniqueId(),
          installment_number: "",
          installment_amount: "",
          installment_date: "",
        },
        {
          id: getUniqueId(),
          installment_number: "",
          installment_amount: "",
          installment_date: "",
        },
        {
          id: getUniqueId(),
          installment_number: "",
          installment_amount: "",
          installment_date: "",
        },
        {
          id: getUniqueId(),
          installment_number: "",
          installment_amount: "",
          installment_date: "",
        },
        {
          id: getUniqueId(),
          installment_number: "",
          installment_amount: "",
          installment_date: "",
        },
        {
          id: getUniqueId(),
          installment_number: "",
          installment_amount: "",
          installment_date: "",
        },
      ],
    },
    loading: LoadState.NotLoaded,
    error: null,
  },
  attachment: {
    list: [],
    listLoading: LoadState.NotLoaded,
    data: {
      customer_policy_id: null,
      serial_number: null,
      document_name: null,
      file_upload: null,
      description: null,
      status: "ACTIVE",
      send_attachment: 0,
    },
    loading: LoadState.NotLoaded,
    error: null,
  },

  customerPoliycId: null,
};
